<div class="perfil" *ngIf="paciente">
    <div class="identificacao">
        <div *ngIf="urlFoto" class="foto-perfil">
            <img [src]="urlFoto" alt="Foto de perfil">
        </div>
        <div *ngIf="!urlFoto" class="foto">
            <i class="hgi hgi-stroke hgi-user"></i>
        </div>
        <div class="nome">
            <h4>{{ paciente.nome }}</h4>
            <span>Paciente</span>
        </div>
    </div>

    <hr>

    <div class="perfil-info">
        <i class="hgi hgi-stroke hgi-student-card"></i>
        <span>{{ paciente.nome }}</span>
    </div>

    <div *ngIf="paciente.email" class="perfil-info">
        <i class="hgi hgi-stroke hgi-mail-01"></i>
        <span>{{ paciente.email }}</span>
    </div>

    <div class="perfil-info">
        <i class="hgi hgi-stroke hgi-birthday-cake"></i>
        <span>{{ paciente.idade }} Anos</span>
    </div>
    <div *ngIf="paciente.sexoDescricao" class="perfil-info">
        <i class="hgi hgi-stroke hgi-dna-01"></i>
        <span>Sexo {{ paciente.sexoDescricao }}</span>
    </div>

    <div *ngIf="alergias.length > 0" class="perfil-info">
        <i class="hgi hgi-stroke hgi-mask"></i>
        <div class="alergias-container">
            <div class="alergias">
                <div class="alergia" *ngFor="let alergia of alergias">
                    <i class="hgi hgi-stroke hgi-alert-02"></i>
                    <span>
                        {{alergia}}
                    </span>
                </div>
                <div *ngIf="totalAlergias > 0" class="alergia">
                    <span>
                        +{{totalAlergias}}
                    </span>
                </div>
            </div>
            <div *ngIf="showLinks" class="link">
                <a class="cursor-pointer" (click)="navigateMinhasAlergias()">
                    Ver detalhes
                    <i class="hgi hgi-stroke hgi-arrow-right-02"></i>
                </a>
            </div>
        </div>
    </div>
    <div *ngIf="showAddAlergia" class="link row col-12">
        <a class="cursor-pointer d-flex align-items-center" (click)="novaAlergia()">
            Nova Alergia
            <i class="hgi hgi-stroke hgi-plus-sign-circle ml-1"></i>
        </a>
    </div>

    <button *ngIf="showLinks" type="button" class="btn btn-lg btn-outline-secondary" (click)="navigateMeusDados()">
        <span>Editar Perfil</span>
        <i class="hgi hgi-stroke hgi-edit-02"></i>
    </button>

</div>